import api from '../api';
import {unauthorize} from './authorization';
import {removeCookie} from '../helpers/cookies';
import {CookieNames} from '../generalTypes';
import {DASHBOARD_URL} from '../constants';

export const logOut = () => async (dispatch: any) => {
    dispatch(unauthorize());
    dispatch(api.util.resetApiState());

    removeCookie(CookieNames.accessToken);
    removeCookie(CookieNames.refreshToken);

    window.location.replace(DASHBOARD_URL);
};
